<div class="tabs-container">
    <ng-content></ng-content>
</div>